import { LoadingOutlined } from '@ant-design/icons';
import { Spin as AntSpin } from 'antd';
import React, { memo } from 'react';

import FarmbotLogoHorizontal from 'components/atoms/FarmbotLogoHorizontal';

type LoadingSpinnerProps = {
  /** Pixel font size for the indicator; when omitted, antd `size="large"` is used (~32px). */
  size?: number;
  color?: React.CSSProperties['color'];
};

function LoadingSpinner({
  size,
  color
}: LoadingSpinnerProps): JSX.Element {
  const indicatorStyle: React.CSSProperties = {
    ...(color !== undefined ? { color } : {}),
    ...(size !== undefined ? { fontSize: size } : {})
  };
  const indicator = <LoadingOutlined style={indicatorStyle} />;
  return (
    <AntSpin
      indicator={indicator}
      size={size === undefined ? 'large' : undefined}
    />
  );
}

function LoadingLogo(): JSX.Element {
  return (
    <div style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }}>
      <FarmbotLogoHorizontal />
    </div>
  );
}

/** Flex-centred wrapper, full width and full height but can be overridden; always renders default LoadingSpinner. */
function LoadingSpinnerDiv({ height, width }: {
  height?: React.CSSProperties['height'];
  width?: React.CSSProperties['width'];
}): JSX.Element {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: width ?? '100%',
      height: height ?? '100%'
    }}>
      <LoadingSpinner />
    </div>
  );
}

const LoadingLogoMemo = memo(LoadingLogo);
const LoadingSpinnerDivMemo = memo(LoadingSpinnerDiv);

export default memo(LoadingSpinner);
export { LoadingLogoMemo as LoadingLogo, LoadingSpinnerDivMemo as LoadingSpinnerDiv };
export type { LoadingSpinnerProps };
